import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
    private readonly count = signal<number>(0);
    readonly hasPending = computed<boolean>(() => this.count() > 0);

    start(): void {
        this.count.update((currentCount) => currentCount + 1);
    }

    stop(): void {
        this.count.update((currentCount) => (currentCount > 0 ? currentCount - 1 : 0));
    }

    hasPendingRequests(): boolean {
        return this.hasPending();
    }
}
